import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALES_BOOK,
  DELETE_SALES_BOOK,
  UPDATE_SALES_BOOK,
  ADD_NEW_SALES_BOOK,
} from "./actionType";

import {
  getSalesBookSuccess,
  getSalesBookFail,
  deleteSalesBookSuccess,
  deleteSalesBookFail,
  updateSalesBookSuccess,
  updateSalesBookFail,
  addSalesBookSuccess,
  addSalesBookFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesBookApi,
  getSalesBookApi,
  updateSalesBookApi,
  deleteSalesBookApi,
  addNewSalesBookApi
} from "../../helpers/backend_helper";

function* getSalesBook({ payload: salesBook }) {
  try {
    const response = yield call(getSalesBookApi, salesBook);
    yield put(getSalesBookSuccess(GET_SALES_BOOK, response.data));
  } catch (error) {
    yield put(getSalesBookFail(GET_SALES_BOOK, error));
  }
}

function* onUpdateSalesBook({ payload: salesBook }) {
  try {
    if (salesBook.setApprove) {
      const response = yield call(approveSalesBookApi, salesBook);
      yield put(updateSalesBookSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesBookApi, salesBook);
      yield put(updateSalesBookSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesBookFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesBook({ payload: salesBook }) {
  try {
    const response = yield call(deleteSalesBookApi, salesBook);
    yield put(deleteSalesBookSuccess({ salesBook, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesBookFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesBook({ payload: salesBook }) {
  try {
    const response = yield call(addNewSalesBookApi, salesBook);
    yield put(addSalesBookSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesBookFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesBook() {
  yield takeEvery(GET_SALES_BOOK, getSalesBook);
}

export function* watchUpdateSalesBook() {
  yield takeEvery(UPDATE_SALES_BOOK, onUpdateSalesBook);
}

export function* watchDeleteSalesBook() {
  yield takeEvery(DELETE_SALES_BOOK, onDeleteSalesBook);
}

export function* watchAddNewSalesBook() {
  yield takeEvery(ADD_NEW_SALES_BOOK, onAddNewSalesBook);
}

function* salesBookSaga() {
  yield all([
    fork(watchGetSalesBook),
    fork(watchDeleteSalesBook),
    fork(watchUpdateSalesBook),
    fork(watchAddNewSalesBook)
  ]);
}

export default salesBookSaga;
